module.exports = __webpack_public_path__ + "static/kuveyt1-09363ee2cc658834a77e1432482ba1cf.png";